import React, {useState} from 'react';
import { Navbar, Container, Form, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';
import logo from '../../images/logo2.png';
import { sendEmail } from '../../redux/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// const RecoverPass = () => {
  const RecoverPass = props => {

  const [correo, setCorreo] = useState('');
  const [validated, setValidated] = useState(false);
  const [loadingType, setLoadingType] = useState('initial');

  //redux
  const dispatch = useDispatch();
  const loading = useSelector(store => store.auth.loading);

  const showMessage = useSelector(store => store.auth.recoverPass);//acceder a la variable


  const handleSubmit= (e)=>{
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    setLoadingType("sendemail");
    dispatch(sendEmail(correo));
  };


  return (
    <>
      <Navbar bg="dark">
        <Container>
          <Navbar.Brand>
            <Link to="/Dashboard-Headcount">
              <img src={logo} className="logo" alt="logo" />
            </Link>
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Container className="mt-4">
        <h6 className="mb-4">Introduce la siguiente información  para  recuperar tu contraseña</h6>
        <Form noValidate validated={validated} className="mb-5" onSubmit={handleSubmit}>
          <Row>
            <Col lg={{ span: 6 }}
                md={{ span: 8 }}
                sm={{ span: 8 }}
                xs={{ span: 12 }}>
              <Form.Group>
                <Form.Label>Usuario o correo electrónico</Form.Label>
                <Form.Control className="rounded-pill" type="email" placeholder="Correo electrónico" 
                  onChange={e => setCorreo(e.target.value)}
                  autoFocus
                />
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              {
                showMessage === true && (
                  <Alert variant="success">
                    Hemos enviado un correo para que puedas recuperar tu contraseña
                  </Alert>
                )
              }
              <div className="mt-4">
                <Button
                  disabled={loading && loadingType === "sendemail"} 
                  className="rounded-pill" 
                  variant="primary" 
                  type="submit">
                    {
                      (loading && loadingType === "sendemail") && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true" />
                      )
                    }
                    Recuperar contraseña</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  )
}

export default RecoverPass
